<template>
  <v-dialog
    v-model="show"
    :max-width="$vuetify.breakpoint.xs ? 'auto' : '500px'"
  >
    <v-card class="rounded-xl" color="#ffffffD9">
      <v-card-title class="">
        <span
          class="
              primary--text
              text-subtitle-2
              text-sm-subtitle-1
              text-md-subtitle-1
              text-lg-subtitle-1
              text-xl-subtitle-1
              font-weight-bold
            "
          >{{ translations.change_language }}</span
        >
      </v-card-title>
      <v-card-text class="my-0 py-0">
        <v-container>
          <v-row class="justify-center">
            <v-col cols="3" class="py-0">
              <v-btn-toggle
                divided
                color="primary"
                v-model="langSelected"
                density="compact"
                class=" justify-center"
              >
                <div v-for="(lang, index) in langs" :key="index">
                  <v-btn @click="updateLamguage(lang.id)">
                    <v-img
                      width="30px"
                      class="mx-auto"
                      :src="lang.icon"
                    ></v-img>
                  </v-btn>
                </div>
              </v-btn-toggle>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-container fluid>
          <v-row justify="end" align="end">
            <v-btn
              color="primary"
              @click="show = false"
              text
              class="
                  text-subtitle-2
                  text-sm-subtitle-1
                  text-md-subtitle-1
                  text-lg-subtitle-1
                  text-xl-subtitle-1
                "
            >
              {{ translations.accept }}
            </v-btn>
          </v-row>
        </v-container>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
// Vuex
import { mapActions, mapGetters, mapState } from "vuex";
export default {
  props: {
    value: Boolean,
  },
  data: () => ({
    langs: [
      {
        id: "en",
        name: "English",
        icon: require("@/assets/img/usa-flag.jpeg"),
      },
      {
        id: "pt",
        name: "Português",
        icon: require("@/assets/img/brazil-flag.png"),
      },
      {
        id: "es",
        name: "Español",
        icon: require("@/assets/img/mexico-flag.png"),
      },
      {
        id: "es-pr",
        name: "Español (Perú)",
        icon: require("@/assets/img/peru_flag.png"),
      },
    ],
    langSelected: 0,
  }),
  async created() {
    if (this.language == "en") {
      this.langSelected = 0;
    } else if (this.language == "es") {
      this.langSelected = 2;
    } else if (this.language == "pt") {
      this.langSelected = 1;
    } else if (this.language == "es-pr") {
      this.langSelected = 3;
    }
  },
  computed: {
    ...mapState("session", ["language"]),
    ...mapGetters("session", ["currentTranslations"]),
    translations() {
      return this.currentTranslations;
    },
    show: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      },
    },
  },
  methods: {
    ...mapActions("session", ["changeLanguage"]),
    updateLamguage(lang) {
      this.changeLanguage(lang);
      this.$router.go(0);
    },
  },
};
</script>

<style scoped></style>
